<template>
  <div class="post-content-data__text" v-html="data">
  </div>
</template>

<style lang="scss">
.post-content-data__text {
  grid-column-start: 2;

  h2 {
    margin: rem-calc(25 0);

    color: $turmeric;
    font-family: $font-family--header;
    font-size: rem-calc(16);
    line-height: rem-calc(22);

    @media #{$medium-up} {
      font-size: rem-calc(22);
      line-height: rem-calc(30);
    }
  }

  table {
    border: 1px solid $boulder;
  }

  td {
    border: 0.5px solid $boulder;
    padding: rem-calc(3);
  }

  p, td {
    font-size: rem-calc(12);
    line-height: rem-calc(20);

    @media #{$medium-up} {
      font-size: rem-calc(16);
      line-height: rem-calc(24);
    }
  }

  a {
    color: $turmeric;
    text-decoration: underline;

    transition: color ease 0.3s;

    &:hover {
      color: $minsk;
    }
  }
}
</style>

<script>
export default {
  props: ['data'],
};
</script>
